export default __webpack_public_path__ + "static/media/uterus.cb352a48.svg";